module.exports = __webpack_public_path__ + "static/OneToTwo-de60f4179ab63b7a3bc4d5422bdde09b.mp4";